import React from "react";
import { Link } from "react-router-dom";

/** Minimal shared shell for buyer-facing auth pages.
 *  Renders the logo + a card centered on a dark background. */
export const UserAuthLayout = ({ title, subtitle, children, footer }) => {
  return (
    <div className="min-h-screen bg-black text-white flex flex-col">
      <header className="px-6 py-5 border-b border-white/5">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          <Link to="/" className="text-xl font-bold tracking-tight">
            Bilhetez
          </Link>
          <Link
            to="/"
            className="text-sm text-zinc-400 hover:text-white transition-colors"
            data-testid="auth-back-home"
          >
            ← Voltar ao site
          </Link>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="w-full max-w-md">
          <div className="bg-zinc-950 border border-white/10 rounded-2xl p-8 shadow-2xl">
            {title && <h1 className="text-2xl font-bold mb-1">{title}</h1>}
            {subtitle && <p className="text-zinc-400 text-sm mb-6">{subtitle}</p>}
            {children}
          </div>
          {footer && <div className="mt-4 text-center text-sm text-zinc-400">{footer}</div>}
        </div>
      </main>
    </div>
  );
};
